export default {
    FULL_ACCESS: 'Full Access',
    NO_ACCESS: 'No Access',
    READ_ONLY: 'Read Only',
};
